import axios from "axios";
import { __constants } from "../constants";
const BASE_URL = process.env.REACT_APP_SERVER_URL;

export const checkOnBoardStatus = async (accountId,token) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + `/v2/stripe/connected-account/retrive/${accountId}`,
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        };
        const response = await axios(config);
        return response;

    } catch (err) {
        return err.response
    }
}

export const getStripeRefreshLink = async (accountId,token) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + `/v2/stripe/connected-account/refresh-link/${accountId}`,
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        };
        const response = await axios(config);
        return response;

    } catch (err) {
        return err.response
    }
}
